import {Component, OnDestroy, OnInit} from '@angular/core';
import {NetworkService} from "../../../services/network.service";
import {Contador} from '../../../model/cadastro/contador.model';
import {ActivatedRoute ,Router} from "@angular/router";
import {getUrlImplante,URL_BASE} from "../../../controller/staticValues";
import {MessageService} from "primeng/api";
import { Subscription } from 'rxjs'
import {Formulario} from "../../../controller/Formulario";
import {DadosDefaultService} from "../../../services/dados-default.service";
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Util } from 'src/app/controller/Util';
import { Endereco, viaCep } from 'src/app/controller/viaCep';

@Component({
    selector: 'app-editar-contador',
    templateUrl: './editar-contador.component.html',
    styleUrls: ['./editar-contador.component.css'],
    standalone: false
})
export class EditarContadorComponent implements OnInit{

  entObj = new Contador()
  public lista: any[] = []
  form: UntypedFormGroup;
  usuario: any;
  filtro: string = ''
  id: any;

  modalPesquisaNcm = false;
  ncmParcialParaPesquisar = undefined;
  modalCepVisible = false;

    constructor(private viaCep: viaCep ,private fb: UntypedFormBuilder,public route: ActivatedRoute, private networkService: NetworkService, private router: Router, private messageService: MessageService, private dadosDefaultService: DadosDefaultService) {
      this.form = Formulario.createForm(this.entObj, this.fb)
    }

    ngOnInit() {
        this.route.paramMap.subscribe(params => {
          this.id = params.get('id');
            if (this.id) {
              this.networkService.buscar('CONTADOR_TOQSYS', this.id, '', getUrlImplante()).subscribe(value => {
                const data = Formulario.prepareValueToForm(this.entObj, value);
                Object.keys(data).forEach(key => this.form.controls[key].setValue(data[key]))
              })
            }
        })
    }

    verificaNcmValido(e: any) {
        if (e.key !== 'Enter' && e.type !== 'blur' || this.form.get('Ncms')?.value === '') return
        const ncm = this.form.get('Ncms')?.value
        this.dadosDefaultService.verificaNcmValido(ncm).subscribe(res => {
        }, error1 => {
            this.ncmParcialParaPesquisar = ncm
            this.messageService.add({severity: 'error', summary: 'Ncm Invalido'})
            this.modalPesquisaNcm = true
        })
    }

    verificaCepValido(event: any) {
        if (event.key === 'Enter' || event.type === 'blur') {
            let result = {};
            let cep = this.form.get('CEP')?.value.toString().match(/\d/g).join('');
            if (cep.length === 8) {
                this.viaCep.buscarPorCep(cep)
                    .then((endereco: Endereco) => {
                        result = endereco;
                        this.form.get('CEP')?.setValue(cep)
                        this.form.get('COMPLEMENTO')?.setValue(endereco.complemento);
                        this.form.get('ENDERECO')?.setValue(endereco.logradouro);
                        this.form.get('BAIRRO')?.setValue(endereco.bairro);
                        this.form.get('CIDADE')?.setValue(endereco.localidade);
                        this.form.get('UF')?.setValue(endereco.uf)
                    }).catch((error: any) => {
                    this.messageService.add(Util.pushErrorMsg(error))
                })
            }
        }
    }

    processarFormulario(){
      const data = Formulario.parseForm(this.entObj, Object.assign(this.form.value), undefined, Contador.mascaras());
      this.networkService.salvarPost(getUrlImplante(), 'adm/ContadorToqSys', data).subscribe(value => {
        this.messageService.add(Util.pushSuccessMsg("Cadastro feito com sucesso!"))
        this.router.navigate(['contador'])
      })
    }

    cancelar(){
      this.router.navigate(['contador']);
    }
}
